import { tripSearchFun, guSearchFun, actSearchFun, campSearchFun } from '../../../api/searchAPI';

import errorHandle from '../../../utils/errorHandle';

export const fetchSearchResult = async (
    type,
    text,
    filters,
    offset,
    limit,
    sortBy,
    setLoading,
    setSearchData,
    setHasMore,
    append = false,
    // optional: gets the full response of a fresh search (camp: facets, total, heroImage)
    onMeta
) => {
    try {
        setLoading(true);

        const priceRange = filters.priceRange || ['', ''];

        // Save as a recent search only for a fresh search (not "Load more")
        const saveRecent = !append && offset === 0;

        const searchMap = {
            /*
             * =========================
             * TRIP SEARCH
             * =========================
             */
            trip: () =>
                tripSearchFun(
                    text,
                    filters.maxDays || '',
                    filters.type || '',
                    filters.base_city,
                    filters.Dates,
                    filters.Group,
                    priceRange[0],
                    priceRange[1],
                    filters.Difficulty,
                    filters.maxNights || '',
                    offset,
                    limit,
                    sortBy || '',
                    saveRecent
                ),

            /*
             * =========================
             * GUIDE / USER SEARCH
             * =========================
             */
            gu: () =>
                guSearchFun(
                    text,
                    filters.base_city || '',
                    filters.area || '',
                    filters.languages || '',
                    filters.value || '',
                    priceRange[0],
                    priceRange[1],
                    offset,
                    limit,
                    sortBy || '',
                    saveRecent
                ),

            /*
             * =========================
             * ACTIVITY SEARCH
             * =========================
             */
            act: () =>
                actSearchFun({
                    place: text.place || '',
                    activity: text.activity || '',
                    minPrice: priceRange[0],
                    maxPrice: priceRange[1],
                    offset,
                    limit,
                    sortBy: sortBy || '',
                    saveRecent
                }),

            /*
             * =========================
             * CAMP / ACCOMMODATION SEARCH
             * =========================
             */
            camp: () =>
                campSearchFun({
                    place: text.place || '',

                    checkin: text.checkin || '',
                    checkout: text.checkout || '',

                    adults: Number(text.adults ?? 1),
                    children: Number(text.children ?? 0),
                    pets: Number(text.pets ?? 0),

                    propertyCategory: filters.propertyCategory || '',

                    // sidebar filters (CampFilters) — saved in the URL
                    propertyTypes: (filters.propertyTypes || []).join(','),
                    unitTypes: (filters.unitTypes || []).join(','),
                    amenities: (filters.amenities || []).join(','),
                    minPrice: filters.minPrice?.[0] || '',
                    maxPrice: filters.maxPrice?.[0] || '',

                    offset,
                    limit,
                    sortBy: sortBy || '',

                    // Save on the first search, not pagination.
                    saveRecent
                })
        };

        /*
         * =========================
         * EXECUTE API
         * =========================
         */
        const search = await searchMap[type]?.();

        if (!search) {
            console.warn(`No API mapped for type: ${type}`);
            return;
        }

        /*
         * =========================
         * COMMON RESPONSE HANDLING
         * =========================
         */
        if (search?.data) {
            const results = Array.isArray(search.data) ? search.data : search.data?.data || [];

            // camp search tells exactly whether more results exist
            const moreFromServer = search.data?.pagination?.hasMore;
            setHasMore(typeof moreFromServer === 'boolean' ? moreFromServer : results.length >= limit);

            if (append) {
                setSearchData((prev) => [...prev, ...results]);
            } else {
                setSearchData(results);
                onMeta?.(search.data);
            }
        }
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};
